export default "__VITE_ASSET__BW0H4ywu__"